import { twipsPerPixel } from '@app/utils/measurement';
import { findRmbgImg } from '@app/utils/utils';
import { getArtworkOriginalSizes } from '@app/utils/hints';

export const getImg2StickerRatio = ({ shape, width: panelWidth, height: panelHeight }, stickerImg, artworkImgName) => {
  if (shape !== 'polygon') return 1;
  if (!(stickerImg?.width && stickerImg?.height)) return 1;

  const { source, width: imgWidth, height: imgHeight } = stickerImg;
  if (source !== artworkImgName) return 1;

  return Math.max(imgWidth / panelWidth, imgHeight / panelHeight, 1);
};

export const getCustomStickerImgSize = (master, stickerImg, artworkImgName, { width: origImgWidth, height: origImgHeight }, { width: stickerWidth, height: stickerHeight }, keepAspect, ppi) => {
  if (!stickerWidth && !stickerHeight) {
    return {
      width: origImgWidth * twipsPerPixel(ppi),
      height: origImgHeight * twipsPerPixel(ppi),
    }
  }
  const img2StickerRatio = getImg2StickerRatio(master, stickerImg, artworkImgName);
  stickerWidth *= img2StickerRatio;
  stickerHeight *= img2StickerRatio;

  const imgAspect = origImgWidth / origImgHeight;

  return {
    width: keepAspect && imgAspect <= 1 ? stickerHeight * imgAspect : stickerWidth,
    height: keepAspect && imgAspect > 1 ? stickerWidth / imgAspect : stickerHeight,
  }
};

export const getCustomStickerSize = ({ width: stickerWidth, height: stickerHeight }, { width: shapeWidth, height: shapeHeight }, keepAspect) => {
  if (!stickerWidth && !stickerHeight) {
    return {
      width: shapeWidth,
      height: shapeHeight,
    }
  }
  const shapeAspect = shapeWidth / shapeHeight;
  return {
    width: keepAspect && shapeAspect <= 1 ? stickerHeight * shapeAspect : stickerWidth,
    height: keepAspect && shapeAspect > 1 ? stickerWidth / shapeAspect : stickerHeight,
  }
};

export const getShapeData = (flow, bgParams, artworkImage) => {
  const { contourCut } = bgParams;
  const { keep, removed } = findRmbgImg(flow);
  const shapeImgField = contourCut ? removed : keep;
  const shapeImgSrc = shapeImgField?.source || artworkImage.name;

  return {
    field: shapeImgField,
    src: shapeImgSrc,
  }
};

export const resizeShapeImgIfNeeded = (shapeData, image, context, master, stickerSize, keepAspect, ppi) => {
  const { lowRes, field, src } = shapeData;
  const artworkOriginalSizes = getArtworkOriginalSizes(context) || lowRes;
  const imageSize = getCustomStickerImgSize(master, field, src, artworkOriginalSizes, stickerSize, keepAspect, ppi);
  image.width = imageSize.width;
  image.height = imageSize.height;
  shapeData.size = imageSize;
  shapeData.image = image;
}